import { styled, TextField, Button, Drawer, Typography, Link, Box, alpha } from "@mui/material";

export const DonationButtonStyle = styled(Button)(({ theme }) => ({
    fontFamily: "Fixel Display, sans-serif",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "22px",
    minWidth: "auto",
    height: "auto",
    padding: "7px 15px 3px 15px",
    background: theme.palette.primary.main,
    color: theme.palette.text.primary,
    borderRadius: "4px",
    fontStyle: "normal",
    "&:hover": { background: theme.palette.primary.main },
    "&& .MuiTouchRipple-child": { backgroundColor: theme.palette.primary.main },
}));

export const TypographyStyle = styled(Typography)(({ theme }) => ({
    fontSize: "14px",
    lineHeight: "22px",
    fontFamily: "Fixel Display, sans-serif",
    padding: "12px 0px",
    margin: "0px 16px",
    borderBottom: "2px solid transparent",
    transition: "border-color 0.3s ease",
    '&:hover': {
        borderBottom: "2px solid #fff",
    },
}));

export const SelectedTypographyStyle = styled(Typography)(({ theme }) => ({
    fontSize: "14px",
    lineHeight: "22px",
    fontFamily: "Fixel Display, sans-serif",
    padding: "12px 16px",
    color: theme.palette.primary.main,
    borderBottom: `2px solid ${theme.palette.primary.main}`
}));